import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {isEmpty} from 'lodash/lang';
import {fetchSchools, fetchUsers} from 'api';
import {AutoSuggestSelect} from 'components/common';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm, buildUserFullName, getAvailableRolesToCreate} from 'utils/common';
import * as permissions from 'utils/permissions';

class UserCreationForm extends React.Component {
  constructor(props) {
    super(props);
    if (props.schoolId) {
      this.availableRoles = getAvailableRolesToCreate('school_coordinator');
    } else {
      this.availableRoles = getAvailableRolesToCreate(props.user.role);
    }
    this.fetchSchools = this.fetchSchools.bind(this);
    this.fetchParents = this.fetchParents.bind(this);
  }

  fetchSchools(value) {
    return fetchSchools(value).then(({records}) => records);
  }

  fetchParents(value) {
    return fetchUsers(value, undefined, undefined, undefined, {role: 'parent'}).then(({records}) =>
      records.map((record) => ({
        id: record.id,
        name: buildUserFullName(record, true),
      })),
    );
  }

  render() {
    const {user, schoolId, role, handleSubmit, pristine, submitting} = this.props;
    const selectedRole = permissions.isTeacher(user.role) ? 'teacher' : isEmpty(role) ? undefined : role.value;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          {(permissions.isKluwellAdmin(user.role) || permissions.isSchoolCoordinator(user.role)) && (
            <Col md={schoolId ? 12 : 6}>
              <Field
                name="role"
                label="Role"
                labelKey="label"
                valueKey="value"
                component={fields.Select}
                options={this.availableRoles}
                required
                validate={[validators.isRequired]}
              />
            </Col>
          )}
          {!schoolId && (
            <Col md={6}>
              {permissions.isSchoolCoordinatorOrTeacher(selectedRole) && (
                <AutoSuggestSelect
                  name="school"
                  label="School"
                  labelKey="name"
                  valueKey="id"
                  onSearch={this.fetchSchools}
                  required
                  validate={[validators.isRequired]}
                />
                // ) : (
                //   permissions.isReader(selectedRole) && (
                //     <AutoSuggestSelect
                //       name="parent"
                //       label="Parent"
                //       labelKey="name"
                //       valueKey="id"
                //       onSearch={this.fetchParents}
                //       required
                //       validate={[validators.isRequired]}
                //     />
                //   )
              )}
            </Col>
          )}
        </Row>
        <Row>
          <Col md={6}>
            {permissions.isSchoolCoordinatorOrTeacher(selectedRole) ? (
              <Field name="username" label="Username" component={fields.Input} />
            ) : (
              <Field
                name="username"
                label="Username"
                component={fields.Input}
                required
                validate={[validators.isRequired, validators.isUsername]}
              />
            )}
          </Col>
          <Col md={6}>
            <Field
              name="email"
              label="E-mail Address"
              component={fields.Input}
              required
              validate={[validators.isRequired, validators.isEmail]}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              name="firstName"
              label="First Name"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="lastName"
              label="Last Name"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Field
              name="password"
              label="Password"
              component={fields.Input}
              required
              type="password"
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="confirmPassword"
              label="Confirm Password"
              component={fields.Input}
              required
              type="password"
              validate={[validators.isRequired, validators.isConfirmPasswordMatch]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.account.get('user').toJS(),
});

export default makeForm(UserCreationForm, 'UserCreationForm', mapStateToProps, null, ['role']);
